module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_7.5594210b.jpg";